module.exports = __webpack_public_path__ + "static/media/luypaerts2.d17391aa.jpg";